const keyboardFocusEnablingSelector = [
  'a[href]',
  'button',
  'input',
  'select',
  'textarea',
  'video[controls]',
  'audio[controls]',
  '[tabindex]',
  '[contenteditable]'
].join(',');

const keyboardFocusDisablingSelector = [
  'input[type="hidden"]',
  ':disabled',
  '[tabindex^="-"]'
].join(',');

export const isKeyboardFocusable = (element, { includeHidden = false } = {}) => {
  const isFocusableElement = element.matches(keyboardFocusEnablingSelector) &&
  !element.matches(keyboardFocusDisablingSelector);

  if (includeHidden) {
    return isFocusableElement;
  }

  return isFocusableElement && !!element.getClientRects().length;
};


export const queryKeyboardFocusableAll = (element, { includeHidden = false } = {}) =>
  [...element.querySelectorAll(keyboardFocusEnablingSelector)]
    .filter((node) => isKeyboardFocusable(node, { includeHidden }));

export const queryKeyboardFocusable = (element, { includeHidden = false } = {}) =>
  queryKeyboardFocusableAll(element, { includeHidden })[0] || null;
